import { render, staticRenderFns } from "./consultDetail.vue?vue&type=template&id=0a46e8d6&scoped=true&"
import script from "./consultDetail.vue?vue&type=script&lang=js&"
export * from "./consultDetail.vue?vue&type=script&lang=js&"
import style0 from "./consultDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./consultDetail.vue?vue&type=style&index=1&id=0a46e8d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a46e8d6",
  null
  
)

export default component.exports